/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import connect from 'react-redux/es/connect/connect';

import {
  selectIdsByGroupId,
  selectItemById
} from 'mt-react-common/common/reducers/listsCollection/reducer';

import MaterialsNotSendItem from './MaterialsNotSendItem';

const tasksExecsNotSendMaterialsCollectionRN =
  'tasksModule.collections.tasksExecsNotSendMaterialsCollection';

// eslint-disable-next-line react/prefer-stateless-function
class TasksExecsMaterialsNotSendBlock extends Component {
  render() {
    return (
      <div className="form-group">
        <figure className="offset_bottom_xs offset_right_xs">
          {this.props.materialsMap.map(materialId => (
            <MaterialsNotSendItem
              key={`materialsNotSendItem-${materialId}`}
              formReduceName={this.props.formReduceName}
              item={this.props.getMaterial(materialId)}
            />
          ))}
        </figure>
      </div>
    );
  }
}

TasksExecsMaterialsNotSendBlock.propTypes = {
  // IN
  formReduceName: PropTypes.string.isRequired,

  // CONNECT
  materialsMap: PropTypes.arrayOf(PropTypes.shape).isRequired,
  getMaterial: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  materialsMap: selectIdsByGroupId(
    state,
    tasksExecsNotSendMaterialsCollectionRN,
    props.execId
  ),
  getMaterial: key =>
    selectItemById(state, tasksExecsNotSendMaterialsCollectionRN, key)
});

// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = (dispatch, props) => ({});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TasksExecsMaterialsNotSendBlock)
);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksExecsForms/TasksExecsMaterialsNotSendBlock/TasksExecsMaterialsNotSendBlock.js